document.addEventListener('DOMContentLoaded', () => {
    const mapContainer = document.getElementById('world-map');
    if (!mapContainer) {
        console.error('Map container #world-map not found.');
        return;
    }

    const width = mapContainer.clientWidth;
    const height = mapContainer.clientHeight;

    const svg = d3.select("#world-map").append("svg")
        .attr("viewBox", `0 0 ${width} ${height}`)
        .attr("width", "100%")
        .attr("height", "100%")
    // .style("cursor", "grab"); // Interaction disabled

    const g = svg.append("g"); // Group for map elements for zooming/panning

    // Define map projection
    const projection = d3.geoMercator()
        .scale(width / 8) // Adjust scale based on width
        .translate([width / 2.5, height / 1.4]); // Center the map slightly lower

    // Define path generator
    const path = d3.geoPath().projection(projection);

    // Add a subtle background rectangle for panning interaction
    svg.insert("rect", "g")
        .attr("width", width)
        .attr("height", height)
        .style("fill", "none")
        .style("pointer-events", "all");


    // --- ID to Name Mapping ---
    // (Add more countries as needed based on ISO 3166-1 numeric codes)
    const countryIdToName = {
        "804": "Ukraine", // Base country (optional to highlight)
        // Import Countries
        "586": "Pakistan",
        "356": "India",
        "792": "Turkey",
        // Export Countries
        "076": "Brazil",
        "231": "Ethiopia",
        // EU Representatives
        "276": "Germany",
        "250": "France",
        "616": "Poland",
        "724": "Spain",
        "380": "Italy",
        // Caucasus/Asia
        "268": "Georgia",
        "051": "Armenia", // Note: IDs can sometimes be strings with leading zeros in datasets
        "860": "Uzbekistan",
        "031": "Azerbaijan",
        "398": "Kazakhstan",
        "404": "Kenya",
        // Find more codes at sources like: https://en.wikipedia.org/wiki/ISO_3166-1_numeric
    };

    // Create reverse mapping (name -> ID) for easier lookup
    const countryNameToId = Object.fromEntries(
        Object.entries(countryIdToName).map(([id, name]) => [name.toLowerCase(), String(id)]) // Store ID as string for consistent lookup
    );
    // --- End Mapping ---

    // Function to highlight import and export countries with different colors
    window.highlightTradeCountries = function (importCountries, exportCountries, importColor = '#7BB320', exportColor = '#7BB320', defaultColor = '#cccccc') {
        if (!g) {
            console.error("Map elements not ready for highlighting.");
            return;
        }

        // Ensure inputs are arrays
        importCountries = Array.isArray(importCountries) ? importCountries : [importCountries];
        exportCountries = Array.isArray(exportCountries) ? exportCountries : [exportCountries];

        // Reset all countries to default color first
        g.selectAll("path.country")
            .classed("import-country", false)
            .classed("export-country", false)
            .attr("fill", defaultColor);

        // Highlight Import Countries
        importCountries.forEach(name => {
            const targetId = countryNameToId[name.toLowerCase()];
            if (targetId) {
                g.selectAll("path.country")
                    .filter(d => String(d.id) === targetId) // Compare as strings
                    .classed("import-country", true)
                    .attr("fill", importColor)
                    .raise();
            } else {
                console.warn(`Import country name "${name}" not found in mapping.`);
            }
        });

        // Highlight Export Countries
        exportCountries.forEach(name => {
            const targetId = countryNameToId[name.toLowerCase()];
            if (targetId) {
                g.selectAll("path.country")
                    .filter(d => String(d.id) === targetId) // Compare as strings
                    .classed("export-country", true)
                    .attr("fill", exportColor) // Export color overrides import if country is in both lists
                    .raise();
            } else {
                console.warn(`Export country name "${name}" not found in mapping.`);
            }
        });
    }


    // Load and display the World Atlas TopoJSON
    const worldAtlasURL = 'https://cdn.jsdelivr.net/npm/world-atlas@1.1.4/world/50m.json'; // Revert to user preferred geometry

    d3.json(worldAtlasURL).then(world => {
        if (!world || !world.objects || !world.objects.countries) {
            console.error('Failed to load or parse world atlas data.');
            mapContainer.innerHTML = '<p class="text-red-500 text-center p-4">Error loading map data.</p>';
            return;
        }

        const countries = topojson.feature(world, world.objects.countries); // Revert to using 'countries' object

        // Draw the countries
        g.selectAll("path.country")
            .data(countries.features)
            .enter().append("path")
            // .each(function(d) { console.log("Bound data for path:", d); }) // Diagnostic log removed
            .attr("class", "country")
            .attr("d", path)
            .attr("fill", "#cccccc") // Default country color
            .attr("stroke", "#ffffff") // Country border color
            .attr("stroke-width", 0.5)
            .attr("data-country-id", d => d.id) // Store country ID
            .on("mouseover", function (event, d) {
                // Darken the current fill color on hover
                const currentFill = d3.select(this).attr("fill");
                const darkerColor = d3.color(currentFill).darker(0.3); // Adjust darkness factor as needed
                d3.select(this).attr("fill", darkerColor);

                // Get country name from the mapping using country ID
                const countryName = countryIdToName[d.id];

                if (!countryName) {
                    return;
                }


                // Create tooltip if it doesn't exist
                let tooltip = d3.select("body").select(".map-tooltip");
                if (tooltip.empty()) {
                    tooltip = d3.select("body").append("div")
                        .attr("class", "map-tooltip")
                        .style("position", "absolute")
                        .style("background", "rgba(0, 0, 0, 0.7)")
                        .style("color", "#fff")
                        .style("padding", "6px 10px")
                        .style("border-radius", "4px")
                        .style("font-size", "14px")
                        .style("pointer-events", "none")
                        .style("opacity", 0)
                        .style("z-index", 1000);
                }

                // Position and show tooltip
                tooltip
                    .html(countryName)
                    .style("left", (event.pageX + 10) + "px")
                    .style("top", (event.pageY - 28) + "px")
                    .transition()
                    .duration(200)
                    .style("opacity", 1);
            })
            .on("mouseout", function (event, d) {
                // Revert to its assigned color (import, export, or default)
                const isImport = d3.select(this).classed("import-country");
                const isExport = d3.select(this).classed("export-country");
                const importColor = '#7BB320';
                const exportColor = '#7BB320';
                const defaultColor = '#cccccc';

                if (isExport) { // Export takes precedence visually if in both
                    d3.select(this).attr("fill", exportColor);
                } else if (isImport) {
                    d3.select(this).attr("fill", importColor);
                } else {
                    d3.select(this).attr("fill", defaultColor);
                }

                // Hide tooltip
                d3.select("body").select(".map-tooltip")
                    .transition()
                    .duration(200)
                    .style("opacity", 0);
            })

        // --- Highlight Import/Export Countries ---
        const importCountries = ['Pakistan', 'India', 'Turkey'];
        const exportCountries = [
            'Germany', 'France', 'Poland', 'Spain', 'Italy', // EU Representatives
            'Brazil', 'Ethiopia', 'Ukraine', 'Kazakhstan', 'Kenya',
            'Georgia', 'Armenia', 'Uzbekistan', 'Azerbaijan' // Caucasus/Asia
        ];
        // Optional: Highlight base country Ukraine separately or add to a list
        // const baseCountry = 'Ukraine';
        // const baseColor = '#FFD700'; // Example: Gold

        setTimeout(() => {
            highlightTradeCountries(importCountries, exportCountries);
        }, 100); // Add small delay for rendering
        // ---------------------------------------
    }).catch(error => {
        console.error('Error loading world atlas data:', error);
        mapContainer.innerHTML = '<p class="text-red-500 text-center p-4">Could not load map data. Please check the console.</p>';
    });
    // Removed mapping and function definition from here - moved earlier in the script
});
